export default "__VITE_ASSET__Brp0fRje__"